import React, { useEffect } from 'react';

const ChatwootWidget: React.FC = () => {
  useEffect(() => {
    // Chatwoot-Konfiguration
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).chatwootSettings = {
      position: "right",
      type: "standard",
      launcherTitle: "Chatten Sie mit uns",
    };

    // Chatwoot-Script laden
    const loadChatwoot = () => {
      const BASE_URL = "https://support.stimm.dev";
      const script = document.createElement('script');
      const firstScript = document.getElementsByTagName('script')[0];
      
      script.src = BASE_URL + "/packs/js/sdk.js";
      script.defer = true;
      script.async = true;
      
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      }
      
      script.onload = () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((window as any).chatwootSDK) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (window as any).chatwootSDK.run({
            websiteToken: "UV4Ma83K3U12KRqkMLr4VZxd",
            baseUrl: BASE_URL,
          });
        }
      };
    };

    // Script nur laden, wenn es noch nicht existiert
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!(window as any).chatwootSDK) {
      loadChatwoot();
    }

    // Cleanup ist hier nicht nötig, da Chatwoot global bleiben soll
  }, []);

  // Komponente rendert nichts sichtbares, da Chatwoot sein eigenes Widget erstellt
  return null;
};

export default ChatwootWidget;
